import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Button, Grid } from '@mui/material';
import Chart from '../chart/Chart';
import AccordionGroup from '../accordionGroup/AccordionGroup';
import { CalculatorsContext } from '../../context';

import { ReactComponent as CloseSvg } from '../../assets/icons/close.svg';
import styles from './SolutionsModal.module.scss';

const SolutionsGlobalModal = ({ activeItem, opened, closeModalFunc, accordionItems }) => {
  const { chartData, lastVisitedIndex } = useContext(CalculatorsContext);

  const [items, setItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [chart, setChart] = useState([]);

  useEffect(() => {
    setSelectedItem(activeItem);
  }, [activeItem]);

  useEffect(() => {
    setItems(accordionItems);
  }, [accordionItems]);

  useEffect(() => {
    setChart(chartData);
  }, [chartData]);

  const onCloseClick = () => {
    setSelectedItem(null);
    closeModalFunc();
  };

  const chartMainReturn = () => {
    setSelectedItem(null);
  };

  useEffect(() => {
    if (!selectedItem) {
      setChart(chartData);
    } else {
      const newChart = [];
      const calcChart = chartData.filter((item) => item.calc === selectedItem);
      if (calcChart && calcChart.length > 0) newChart.push(...calcChart);
      else {
        const childChart = chartData.find(
          (item) =>
            item.name === selectedItem || item?.children?.some((cat) => cat.name === selectedItem)
        );
        newChart.push(...(childChart?.children ?? [childChart]));
      }
      setChart(newChart);
    }
    const newItems = [
      ...accordionItems.map((item) => ({
        ...item,
        children: [
          ...item.children.map((scope) => ({
            ...scope,
            children: [
              ...scope.children.map((cat) => ({
                ...cat,
                expanded: cat.name === selectedItem,
              })),
            ],
            expanded:
              scope.name === selectedItem ||
              scope.children.some((cat) => cat.name === selectedItem),
          })),
        ],
        expanded:
          item.name === selectedItem ||
          item.children.some(
            (scope) =>
              scope.name === selectedItem || scope.children.some((cat) => cat.name === selectedItem)
          ),
      })),
    ];
    setItems(newItems);
  }, [selectedItem]);

  const onChartSectorClick = (active) => {
    setSelectedItem(active);
  };

  const setNewSelected = (selected, clicked) => {
    const newSelected = selected
      ? clicked
      : items.find((item) => item.children.some((cat) => cat.name === clicked))?.name;
    setSelectedItem(newSelected);
  };

  const onAccordionClick = (selected, clicked) => {
    setNewSelected(selected, clicked);
  };

  return (
    <>
      {opened && (
        <div className={styles.modal}>
          <Button variant="text" className={styles.closeBtn} onClick={onCloseClick}>
            <CloseSvg className={styles.closeSvg} />
          </Button>
          <Grid
            item
            container
            alignItems="center"
            justifyContent="center"
            className={styles.content}
          >
            <div className={styles.chartArea}>
              <Chart
                chartData={chart}
                activeItem={selectedItem}
                onSectorClick={onChartSectorClick}
                hasDesktopFormat
                lastIndex={lastVisitedIndex}
                onCenterClick={chartMainReturn}
              />
            </div>
            <div className={styles.accordionArea}>
              <AccordionGroup items={items} onAccordionClick={onAccordionClick} />
            </div>
          </Grid>
        </div>
      )}
    </>
  );
};

SolutionsGlobalModal.propTypes = {
  activeItem: PropTypes.string,
  opened: PropTypes.bool,
  closeModalFunc: PropTypes.func,
};

SolutionsGlobalModal.defaultProps = {
  activeItem: '',
  opened: false,
  closeModalFunc: () => {},
};

export default SolutionsGlobalModal;
